export const defaultCookiesParamsMaxTime = {
  path: '/',
  expires: new Date(2147483647 * 1000), // http://www.faqs.org/rfcs/rfc2616.html
}
